export default __webpack_public_path__ + "static/media/Programme-Regular.92ada59e.ttf";